import type { SystemStyleObject } from "@chakra-ui/react";
import { selectStylings } from "./components/select";
import { lrnCorrectIcon, lrnIncorrectIcon } from "./common";

const feedbackIconBase = {
  content: "\"\"",
  width: "16px",
  height: "16px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  left: "8px",
  top: "25%",
  transform: "translateY(-50%)",
  fontSize: "sm",
  fontWeight: "bold",
  color: "base.200",
  pointerEvents: "none",

  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "16px 16px"
};

const feedbackBase = {
  "bg": "button.bg.hollow !important",
  "borderColor": "lines !important",
  "borderWidth": "2px !important",
  "borderStyle": "solid !important",
  "borderRadius": "5px !important",
  "p": "3 !important",
  "paddingLeft": "2em !important",
  "boxSizing": "border-box",
  "display": "inline-flex",

  "&:after": {
    display: "none !important"
  },

  "&:before": feedbackIconBase
};

// Shared styling for correct/incorrect states
const feedbackStateBase = {
  "bg": "transparent !important",

  "& .lrn_clozedropdown_answer:before": {
    padding: "0"
  }
};

export const lrnClozeDropdownStylings: SystemStyleObject = {
  "& .lrn_qr.lrn_clozedropdown": {
    "& .lrn_response.lrn_cloze .lrn_combobox": {
      ...selectStylings
    },

    "& select.lrn-cloze-select": {
      backgroundColor: "base.200 !important",
      color: "base.700 !important",
      colorScheme: "light",
      WebkitTextFillColor: "base.700 !important"
    },

    "& select.lrn-cloze-select option": {
      backgroundColor: "base.200 !important",
      color: "base.700 !important"
    },

    "& .lrn_combobox": {
      "display": "inline-block",
      "marginBottom": "2",
      "minHeight": "50px",

      "& .lrn_responseIndex": {
        display: "none !important"
      },

      "& .lrn_clozedropdown_answer": feedbackBase,

      "&.lrn_incorrect": {
        ...feedbackStateBase,

        "& .lrn_clozedropdown_answer": {
          "background": "base.200 !important",
          "borderColor": "danger.500 !important",
          "paddingRight": "1.25em !important",

          "& span": {
            color: "base.700 !important"
          },

          "&:before": {
            ...feedbackIconBase,
            ...lrnIncorrectIcon
          }
        }
      },

      "&.lrn_correct": {
        ...feedbackStateBase,

        "& .lrn_clozedropdown_answer": {
          "background": "base.200 !important",
          "borderColor": "success.700 !important",
          "paddingRight": "1em !important",

          "& span": {
            color: "base.700 !important"
          },

          "&:before": {
            ...feedbackIconBase,
            ...lrnCorrectIcon
          }
        }
      }
    },

    "& .lrn_cloze_response_container": {
      "& .lrn-response-validate-wrapper.lrn_incorrect .lrn_response_input > div":
        {
          lineHeight: "2.5"
        },

      "& .lrn-response-validate-wrapper.lrn_correct .lrn_response_input > div":
        {
          lineHeight: "2.5"
        }
    }
  },

  "& div[data-correct-answer-clone] .lrn_qr.lrn_clozedropdown": {
    "& .lrn_combobox": {
      "& .lrn_clozedropdown_answer": {
        "background": "var(--euka-colors-base-200)!important",
        "borderColor": "success.700 !important",
        "color": "var(--euka-colors-base-700) !important",

        "&:before": {
          ...lrnCorrectIcon
        },

        "& span:not([class])": {
          "color": "var(--euka-colors-base-700) !important",
        },
      },
    }
  }
};
